import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { storage } from "../firebase/firebase-config";
import { getDownloadURL, ref } from "firebase/storage";

interface OpenPdfProps {
  name: string;
  filePath: string;
}

const OpenPdf: React.FC<OpenPdfProps> = ({ name, filePath }) => {
  const [pdfUrl, setPdfUrl] = useState<string>("");

  useEffect(() => {
    const fetchPdf = async () => {
      const fileRef = ref(storage, filePath);
      const url = await getDownloadURL(fileRef);
      setPdfUrl(url);
    };
    fetchPdf();
  }, [filePath]);

  const handleOpenPdf = () => {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
    } else {
      alert("PDF is not available at the moment.");
    }
  };

  return (
    <a href={pdfUrl} target="_blank" className="link-primary">
      {name} öffnen
    </a>
  );
};

export default OpenPdf;
